import { connect } from 'react-redux';
import PresentationComponent from '../../components/event/EventQueryExposureModal';
import { getUsersEvent, getUsersExposureError, getUsersSQL } from '../../reducers/analyticsApp';
import { exposeUsersQuery } from '../../actions/users';

const mapStateToProps = (state) => ({
  sql: getUsersSQL(state),
  error: getUsersExposureError(state),
  updatingItems: getUsersEvent(state),
  showButton: true,
});

const mapDispatchToProps = (dispatch) => ({
  expose: () => dispatch(exposeUsersQuery()),
});

const EventsQueryExposureModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(PresentationComponent);

export default EventsQueryExposureModal;
